import {
	IEditTeaserTotalSchedule,
	IInitialFormData,
	TEditTeaserControlPoint,
	TEditTeaserSelectedContentType,
	TEditTeaserTransitionType,
	TEditTeaserVisibleForm,
	TSourceUrlLocally,
	TTypeOfEditTeaserModalWindow,
} from './editTeaserContext';
import { IItemForGetShortInfo, TFileId, IEditTeaser, ITeaserDishTransition } from 'types';

export enum EditTeaserActionTypes {
	REFETCH_DATA = 'REFETCH_DATA',
	SET_INITIAL_FORM_DATA = 'SET_INITIAL_FORM_DATA',
	SET_ALL_DATA = 'SET_ALL_DATA',
	CHANGE_VISIBLE_FORM = 'CHANGE_VISIBLE_FORM',
	SET_FILE = 'SET_FILE',
	DELETE_VIDEO = 'DELETE_VIDEO',
	SET_FETCHED_CUSTOMERS = 'SET_FETCHED_CUSTOMERS',
	SET_CUSTOMER = 'SET_CUSTOMER',
	SET_FETCHED_RESTAURANTS = 'SET_FETCHED_RESTAURANTS',
	SET_RESTAURANTS = 'SET_RESTAURANTS',
	SET_CONTENT_TYPE = 'SET_CONTENT_TYPE',
	CHANGE_DESCRIPTION = 'CHANGE_DESCRIPTION',
	CHANGE_SCHEDULE = 'CHANGE_SCHEDULE',
	CHANGE_ADDITIONAL_SCHEDULE = 'CHANGE_ADDITIONAL_SCHEDULE',
	SET_SCHEDULES = 'SET_SCHEDULES',
	SET_TRANSITION_TYPE = 'SET_TRANSITION_TYPE',
	SET_FETCHED_DISH_CATEGORIES = 'SET_FETCHED_DISH_CATEGORIES',
	SET_TRANSITION_DISH_CATEGORY = 'SET_TRANSITION_DISH_CATEGORY',
	SET_FETCHED_DISH_SUB_CATEGORIES = 'SET_FETCHED_DISH_SUB_CATEGORIES',
	SET_TRANSITION_DISH_SUB_CATEGORY = 'SET_TRANSITION_DISH_SUB_CATEGORY',
	SET_FETCHED_DISHES = 'SET_FETCHED_DISHES',
	SET_TRANSITION_DISH_NAME = 'SET_TRANSITION_DISH_NAME',
	SET_FETCHED_GAME_CATEGORIES = 'SET_FETCHED_GAME_CATEGORIES',
	SET_TRANSITION_GAME_CATEGORY = 'SET_TRANSITION_GAME_CATEGORY',
	SET_FETCHED_GAMES = 'SET_FETCHED_GAMES',
	SET_TRANSITION_GAME_NAME = 'SET_TRANSITION_GAME_NAME',
	SET_CONTROL_POINT = 'SET_CONTROL_POINT',
	CHANGE_DELAY_TIME = 'CHANGE_DELAY_TIME',
	CHANGE_LAUNCH_COUNT = 'CHANGE_LAUNCH_COUNT',
	CHANGE_COUNTDOWN = 'CHANGE_COUNTDOWN',
	SET_DATA_FOR_SUBMIT = 'SET_DATA_FOR_SUBMIT',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	RESET_FIELDS = 'RESET_FIELDS',
}

interface IRefetchData {
	type: EditTeaserActionTypes.REFETCH_DATA;
	payload: {
		needRefetch: boolean;
	};
}

interface ISetInitialFormData {
	type: EditTeaserActionTypes.SET_INITIAL_FORM_DATA;
	payload: {
		initialFormData: IInitialFormData;
	};
}

interface ISetAllData {
	type: EditTeaserActionTypes.SET_ALL_DATA;
	payload: {
		teaserID: string;
		filePath: string;
		selectedCustomer: Nullable<string>;
		selectedRestaurants: string[];
		selectedContentType: TEditTeaserSelectedContentType;
		description: string;
		schedule: string;
		totalSchedules: IEditTeaserTotalSchedule[];
		selectedTransitionType: TEditTeaserTransitionType;
		dishTransition: Nullable<ITeaserDishTransition>;
		selectedTransitionDishCategory: Nullable<string>;
		selectedTransitionDishSubCategory: Nullable<string>;
		selectedTransitionDishName: Nullable<string>;
		selectedTransitionGameCategory: Nullable<string>;
		selectedTransitionGameName: Nullable<string>;
		selectedControlPoint: TEditTeaserControlPoint;
		delayTime: string;
		launchCount: string;
		countDown: string;
	};
}

interface IChangeVisibleForm {
	type: EditTeaserActionTypes.CHANGE_VISIBLE_FORM;
	payload: {
		visibleForm: TEditTeaserVisibleForm;
	};
}

interface ISetFile {
	type: EditTeaserActionTypes.SET_FILE;
	payload: {
		fileId: TFileId;
		sourceUrlLocally: TSourceUrlLocally;
	};
}

interface IDeleteVideo {
	type: EditTeaserActionTypes.DELETE_VIDEO;
}

interface ISetFetchedCustomers {
	type: EditTeaserActionTypes.SET_FETCHED_CUSTOMERS;
	payload: {
		customers: IItemForGetShortInfo[];
	};
}

interface ISetCustomer {
	type: EditTeaserActionTypes.SET_CUSTOMER;
	payload: {
		customer: Nullable<string>;
	};
}

interface ISetFetchedRestaurants {
	type: EditTeaserActionTypes.SET_FETCHED_RESTAURANTS;
	payload: {
		restaurants: IItemForGetShortInfo[];
	};
}

interface ISetRestaurants {
	type: EditTeaserActionTypes.SET_RESTAURANTS;
	payload: {
		restaurants: string[];
	};
}

interface ISetContentType {
	type: EditTeaserActionTypes.SET_CONTENT_TYPE;
	payload: {
		contentType: TEditTeaserSelectedContentType;
	};
}

interface IChangeDescription {
	type: EditTeaserActionTypes.CHANGE_DESCRIPTION;
	payload: {
		description: string;
	};
}

interface IChangeSchedule {
	type: EditTeaserActionTypes.CHANGE_SCHEDULE;
	payload: {
		schedule: string;
	};
}

interface IChangeAdditionalSchedule {
	type: EditTeaserActionTypes.CHANGE_ADDITIONAL_SCHEDULE;
	payload: {
		updatedSchedules: IEditTeaserTotalSchedule[];
	};
}

interface ISetSchedules {
	type: EditTeaserActionTypes.SET_SCHEDULES;
	payload: {
		updatedSchedules: IEditTeaserTotalSchedule[];
	};
}

interface ISetTransitionType {
	type: EditTeaserActionTypes.SET_TRANSITION_TYPE;
	payload: {
		transitionType: TEditTeaserTransitionType;
	};
}

interface ISetFetchedDishCategories {
	type: EditTeaserActionTypes.SET_FETCHED_DISH_CATEGORIES;
	payload: {
		dishCategories: IItemForGetShortInfo[];
	};
}

interface ISetTransitionDishCategory {
	type: EditTeaserActionTypes.SET_TRANSITION_DISH_CATEGORY;
	payload: {
		transitionDishCategory: Nullable<string>;
	};
}

interface ISetFetchedDishSubCategories {
	type: EditTeaserActionTypes.SET_FETCHED_DISH_SUB_CATEGORIES;
	payload: {
		dishSubCategories: IItemForGetShortInfo[];
	};
}

interface ISetTransitionDishSubCategory {
	type: EditTeaserActionTypes.SET_TRANSITION_DISH_SUB_CATEGORY;
	payload: {
		transitionDishSubCategory: Nullable<string>;
	};
}

interface ISetFetchedDishes {
	type: EditTeaserActionTypes.SET_FETCHED_DISHES;
	payload: {
		dishes: IItemForGetShortInfo[];
	};
}

interface ISetTransitionDishName {
	type: EditTeaserActionTypes.SET_TRANSITION_DISH_NAME;
	payload: {
		transitionDishName: Nullable<string>;
	};
}

interface ISetFetchedGameCategories {
	type: EditTeaserActionTypes.SET_FETCHED_GAME_CATEGORIES;
	payload: {
		gameCategories: IItemForGetShortInfo[];
	};
}

interface ISetTransitionGameCategory {
	type: EditTeaserActionTypes.SET_TRANSITION_GAME_CATEGORY;
	payload: {
		transitionGameCategory: Nullable<string>;
	};
}

interface ISetFetchedGames {
	type: EditTeaserActionTypes.SET_FETCHED_GAMES;
	payload: {
		games: IItemForGetShortInfo[];
	};
}

interface ISetTransitionGameName {
	type: EditTeaserActionTypes.SET_TRANSITION_GAME_NAME;
	payload: {
		transitionGameName: Nullable<string>;
	};
}

interface ISetControlPoint {
	type: EditTeaserActionTypes.SET_CONTROL_POINT;
	payload: {
		controlPoint: TEditTeaserControlPoint;
	};
}

interface IChangeDelayTime {
	type: EditTeaserActionTypes.CHANGE_DELAY_TIME;
	payload: {
		delayTime: string;
	};
}

interface IChangeLaunchCount {
	type: EditTeaserActionTypes.CHANGE_LAUNCH_COUNT;
	payload: {
		launchCount: string;
	};
}

interface IChangeCountDown {
	type: EditTeaserActionTypes.CHANGE_COUNTDOWN;
	payload: {
		countDown: string;
	};
}

interface ISetDataForSubmit {
	type: EditTeaserActionTypes.SET_DATA_FOR_SUBMIT;
	payload: {
		dataForSubmit: IEditTeaser | null;
	};
}

interface IChangeTypeOfModalWindow {
	type: EditTeaserActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: TTypeOfEditTeaserModalWindow;
	};
}

interface IResetSelectedControls {
	type: EditTeaserActionTypes.RESET_FIELDS;
}

export type TEditTeaserAction =
	| IRefetchData
	| ISetInitialFormData
	| ISetAllData
	| IChangeVisibleForm
	| ISetFile
	| IDeleteVideo
	| ISetFetchedCustomers
	| ISetCustomer
	| ISetFetchedRestaurants
	| ISetRestaurants
	| ISetContentType
	| IChangeDescription
	| ISetSchedules
	| IChangeSchedule
	| IChangeAdditionalSchedule
	| ISetTransitionType
	| ISetFetchedDishCategories
	| ISetTransitionDishCategory
	| ISetFetchedDishSubCategories
	| ISetTransitionDishSubCategory
	| ISetFetchedDishes
	| ISetTransitionDishName
	| ISetFetchedGameCategories
	| ISetTransitionGameCategory
	| ISetFetchedGames
	| ISetTransitionGameName
	| ISetControlPoint
	| IChangeDelayTime
	| IChangeLaunchCount
	| IChangeCountDown
	| ISetDataForSubmit
	| IChangeTypeOfModalWindow
	| IResetSelectedControls;
